import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="ml-gold" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--ml-gold-1, #E8C766)" />
        <stop offset="0.5" stopColor="var(--ml-gold-2, #D4AF37)" />
        <stop offset="1" stopColor="var(--ml-gold-3, #9C7C1E)" />
      </linearGradient>
    </defs>
    {/* Crescent moon — opening to the upper right */}
    <path
      d="M 37.3 14.6 A 40 40 0 1 0 79.1 73.2 A 36 36 0 0 1 37.3 14.6 Z"
      stroke="url(#ml-gold)"
      strokeWidth="2.4"
      fill="none"
      strokeLinejoin="round"
    />
    {/* Magnolia petals fanning into the crescent bowl */}
    <g stroke="url(#ml-gold)" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M 0 0 C -6.5 -11 -6.5 -24 0 -32 C 6.5 -24 6.5 -11 0 0 Z" transform="translate(47 64) rotate(-6)" />
      <path d="M 0 0 C -7 -12 -7 -26 0 -35 C 7 -26 7 -12 0 0 Z" transform="translate(47 64) rotate(20)" />
      <path d="M 0 0 C -6.5 -11 -6.5 -24 0 -32 C 6.5 -24 6.5 -11 0 0 Z" transform="translate(47 64) rotate(46)" />
      <path d="M 0 0 C -6 -10 -6 -21 0 -28 C 6 -21 6 -10 0 0 Z" transform="translate(47 64) rotate(70)" />
      <path d="M 0 0 C -5 -8.5 -5 -18 0 -24 C 5 -18 5 -8.5 0 0 Z" transform="translate(47 64) rotate(92)" />
    </g>
  </svg>
);

export const Logo = ({ compact = false }) => (
  <Link to="/" data-testid="logo-link" className="group flex items-center gap-3 select-none">
    <LogoMark className={compact ? "h-9 w-9" : "h-11 w-11"} />
    <span className="flex flex-col items-center leading-none">
      <span
        className={`font-display font-medium uppercase text-gold transition-colors duration-300 group-hover:text-gold-light ${
          compact ? "text-lg" : "text-lg sm:text-[22px]"
        }`}
        style={{ letterSpacing: "0.16em", marginRight: "-0.16em" }}
      >
        Magnolia
      </span>
      <span
        className={`mt-1 uppercase text-gold/75 transition-colors duration-300 group-hover:text-gold ${
          compact ? "text-[7px]" : "text-[7px] sm:text-[8.5px]"
        }`}
        style={{ letterSpacing: "0.52em", marginRight: "-0.52em" }}
      >
        Lunar Spa
      </span>
    </span>
  </Link>
);
